import TYPES from '../../types';

// Domain
import {
  LevelOfEducationEntity,
} from '../../domain/entities/level-of-education-entity';
import { LevelOfEducationRepository } from '../../domain/repositories/level-of-education-repository';
import { StateManager } from '../../domain/state/state-manager';
import Query from '@/modules/shared/domain/use-cases/query';
import Injectable from '@/modules/shared/domain/di/injectable';
import Inject from '@/modules/shared/domain/di/inject';

@Injectable()
export default class GetAllLevelOfEducationQuery extends
  Query<Promise<Array<LevelOfEducationEntity>>> {
  @Inject(TYPES.LEVEL_OF_EDUCATION_STATE_MANAGER)
  private readonly state_manager!: StateManager;

  @Inject(TYPES.LEVEL_OF_EDUCATION_REPOSITORY)
  private readonly repository!: LevelOfEducationRepository;

  internalExecute(): Promise<Array<LevelOfEducationEntity>> {
    return new Promise((resolve, reject) => {
      if (this.state_manager.state.loaded) {
        resolve(this.state_manager.state.items);
      } else {
        this.repository.get()
          .then((items) => {
            this.state_manager.patch({ items, loaded: true });
            resolve(items);
          })
          .catch(reject);
      }
    });
  }
}
